import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["user"]),
  },

  methods: {
    teamIdentifier(team) {
      return this.$Spark("teamsIdentifiedByPath") ? team.slug : team.id;
    },

    isTeamOwner(team) {
      return this.user && this.user.id === team.owner.id;
    },
  },
};
